import { z } from 'zod';

// Schema for eAlert form
export const eAlertSchema = z.object({
  contact_id: z.string().trim().min(1, 'Contact ID is required'),
  organization_id: z.string().trim().optional(),
  interval: z.enum(['daily', 'weekly', 'bi-weekly']),
  // Location parameters (optional)
  city: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  cities: z.array(z.string()).optional(),
  state: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  subdivision: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Search parameters (optional)
  q: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Property specifications (optional)
  bedrooms: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  min_bedrooms: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  max_bedrooms: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  bathrooms: z
    .union([z.number().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseFloat(val) : val)),
  min_bathrooms: z
    .union([z.number().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseFloat(val) : val)),
  max_bathrooms: z
    .union([z.number().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseFloat(val) : val)),
  min_price: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  max_price: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  property_type: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  propertysubtype: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  status: z
    .string()
    .trim()
    .optional()
    .transform((val) => (val === '' ? undefined : val)),
  // Boolean features (optional)
  waterfront: z.boolean().optional(),
  pool: z.boolean().optional(),
  basement: z.boolean().optional(),
  garage: z.boolean().optional(),
  city_view: z.boolean().optional(),
  mountain_view: z.boolean().optional(),
  park_view: z.boolean().optional(),
  water_view: z.boolean().optional(),
  rental_only: z.boolean().optional(),
  randomize_initial_alert: z.boolean().optional(),
  // Square footage (optional)
  sqft_min: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  sqft_max: z
    .union([z.number().int().positive(), z.string()])
    .optional()
    .transform((val) => (typeof val === 'string' && val !== '' ? parseInt(val, 10) : val)),
  // Test mode parameters (optional)
  skip_callback: z.boolean().optional(),
  test_mode: z.boolean().optional(),
});

// Type for eAlert form data
export type EAlertFormData = z.infer<typeof eAlertSchema>;
